{
  "name": "18-(3,7,11) < 256°",
  "description": "18-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes 3, 7, and 11. By including 3 primes in addition to 2 (which is treated as an equivalence relation in all of these sets), the harmonic dimensionality is increased. It is possible, for example, to move between consonant four-note chords featuring different primes, connected by common tones. These relationships may be more easily imagined with the help of the HEJI notation (see the next scale).",
  "scale": [
    "33/32",
    "9/8",
    "147/128",
    "77/64",
    "81/64",
    "21/16",
    "11/8",
    "189/128",
    "3/2",
    "49/32",
    "99/64",
    "27/16",
    "7/4",
    "231/128",
    "121/64",
    "243/128",
    "63/32",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPart(3,7,11)",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": [
    "1",
    "33",
    "9",
    "147",
    "77",
    "81",
    "21",
    "11",
    "189",
    "3",
    "49",
    "99",
    "27",
    "7",
    "231",
    "121",
    "243",
    "63"
  ],
  "note_colors": [
    "#ff9c9c",
    "#dfffd6",
    "#ffffff",
    "#f8c9c9",
    "#e9ecc1",
    "#ffffff",
    "#ffe5e5",
    "#dfffd6",
    "#ffe5e5",
    "#ffffff",
    "#f8c9c9",
    "#dfffd6",
    "#ffffff",
    "#ffe5e5",
    "#e9ecc1",
    "#c3ffad",
    "#ffffff",
    "#ffe5e5"
  ],
  "equivSteps": 18,
  "fundamental": 440,
  "reference_degree": 12,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
